export default __webpack_public_path__ + "static/media/bgloader.089ccff2.svg";